(() => {
    const toggle = document.querySelector('.nav__toggle');
    const nav = document.querySelector('.nav-overlay');

    if (!toggle) return;

    const focusableSelectors =
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getFocusableElements() {
        // Filter out display:none elements (e.g. collapsible toggles hidden on desktop)
        const navElements = Array.from(nav.querySelectorAll(focusableSelectors)).filter(
            (el) => el.offsetWidth > 0 || el.offsetHeight > 0
        );
        // Include the toggle (close button) at the end of the cycle
        return [...navElements, toggle];
    }

    function trapFocus(e) {
        if (e.key === 'Escape') {
            closeNav();
            return;
        }

        if (e.key !== 'Tab') return;

        const focusable = getFocusableElements();
        if (!focusable.length) return;

        e.preventDefault();

        const index = focusable.indexOf(document.activeElement);

        if (index === -1) {
            focusable[0].focus();
        } else if (e.shiftKey) {
            focusable[index > 0 ? index - 1 : focusable.length - 1].focus();
        } else {
            focusable[index < focusable.length - 1 ? index + 1 : 0].focus();
        }
    }

    function openNav() {
        toggle.classList.add('nav__toggle--active');
        nav.classList.add('nav-overlay--active');
        document.body.classList.add('overflow-hidden', 'nav--open');
        toggle.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', trapFocus);
        // Wait for visibility transition before moving focus
        setTimeout(() => getFocusableElements()[0]?.focus(), 50);
    }

    function closeNav() {
        toggle.classList.remove('nav__toggle--active');
        nav.classList.remove('nav-overlay--active');
        document.body.classList.remove('overflow-hidden', 'nav--open');
        toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', trapFocus);
        toggle.focus();
    }

    toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        isOpen ? closeNav() : openNav();
    });
})();
